module.exports = __webpack_public_path__ + "static/media/contacts.ae7759bc.svg";